import { ProductInterface } from '../../Model/Product';
import { AttributeUtility } from '../../Service/AttributeUtility';
import { ObjectUtility } from '../../Service/ObjectUtility';
import { OptionsCollection } from '../Filter/OptionsCollection';

interface ProtectionClassProps {
    allProducts: ProductInterface[],
    filteredProducts: ProductInterface[],
}

export class ProtectionClassCollector {
    public static collectAvailableProtectionClass(
        props: ProtectionClassProps,
        fetchFromParent: boolean
    ): OptionsCollection<string> {
        const all = this.collectProtectionClass(props.allProducts, fetchFromParent);
        const filtered = this.collectProtectionClass(props.filteredProducts, fetchFromParent);

        return new OptionsCollection(all.map(value => {
            const isAvailable = filtered.contains(value.name);

            return value.withIsAvailable(isAvailable);
        }));
    }

    private static collectProtectionClass(
        products: ProductInterface[],
        fetchFromParent: boolean
    ): OptionsCollection<string> {
        if (fetchFromParent) {
            return OptionsCollection.fromAttributesArray(
                products.flatMap(p => ObjectUtility.valueForKeyPath(p, 'Schutzart') || []),
            );
        }

        return OptionsCollection.fromAttributesArray(
            AttributeUtility.childAttributesForKeyFiltered(products, 'Schutzart')
        );
    }
}
